export const REGEX_EMAIL =
	/^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;

export const REGEX_CONFIRMATION_CODE_DIGIT = /\d/;

export const REGEX_CONFIRMATION_CODE = /\d{6}/;
